/**
 * A row of selectable cards for switching a single value (e.g. the language a
 * page is scoped to). App-agnostic: the caller maps domain values to
 * {value,label,sub}. Render it only when there's more than one option.
 */
export function CardSwitch({
  label,
  options,
  value,
  onChange,
}: {
  label?: string;
  options: { value: string; label: string; sub?: string }[];
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <div style={{ marginBottom: 20 }}>
      {label && (
        <div
          style={{
            fontSize: 11,
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
            color: 'var(--ink-faint)',
            fontWeight: 600,
            marginBottom: 8,
          }}
        >
          {label}
        </div>
      )}
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        {options.map((o) => (
          <button
            type="button"
            key={o.value}
            className={'langcard' + (o.value === value ? ' on' : '')}
            onClick={() => onChange(o.value)}
          >
            <span className="lc-main">{o.label}</span>
            {o.sub && <span className="lc-sub">{o.sub}</span>}
          </button>
        ))}
      </div>
    </div>
  );
}
